import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Button, Checkbox, Table, TableBody, TableCell, TableRow} from '@material-ui/core';
import {Paper, Menu, MenuItem, IconButton} from '@material-ui/core';

import { CheckBox, MoreVert } from '@material-ui/icons';
import { Switch } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import { decimalColorToHexColor } from '../../../../api/helpers';

class GeofencesListEditor_ extends React.Component {


    constructor(props){
        super(props)

        this.state = {menuAnchor: null, menuGeofence: null}

        this.handleInput = this.handleInput.bind(this)
    }

    handleMenuClick(event, geofence){
        this.setState({menuAnchor: event.currentTarget, menuGeofence: geofence});
        event.stopPropagation();
    }

    handleMenuClose(){
        //this.menuAnchor = null;
        this.setState({menuAnchor: null, menuGeofence: null});
        return null;
    }

    handleMenuItemClick(menu){
        const geofence = this.state.menuGeofence
        this.handleMenuClose();
        this.props.onContextMenu(menu, geofence)
    }

    handleSelect(ID){
        this.props.onSelect(ID)
    }

    getItemStyle(ID){
        let selected = ID === this.props.selectedID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleInput(event, ID){
        const changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value 
        
        //alert('GEOFENCE_SET_PROPERTY '+ event.target.name + ' ' + val  + ' ' + ID + '; '+ event.target.type)
        this.props.onAction({type:'GEOFENCE_SET_PROPERTY', id: ID, name: event.target.name, value: val })
    }

    handlePaintClick(event, geofence){
        this.props.onAction({type:'GEOFENCE_SWITCH_PAINT_TOOL', id: geofence.ID })
    }

    getPaintButtonColor(id){
        let color = this.props.geofencePaintID==id ? "primary" : "inherit" 
        return color
    }

    render(){
            const {t, geofences} = this.props
    
            //this.props.users.sort(sortByOnlineName)
    
            const styles = {
                paper: {
                  width: '100%',
                  overflowX: 'auto',
                },
                head: {
                    color: theme.palette.color.dialogTitle,
                    backgroundColor: theme.palette.background.dialogTitle,
                }
            };
    
            /*
            const users = this.props.users.map((user)=>{
                user.StatusName = null
                user.StatusColor = null
                if(user.StatusID!==undefined){
                    const statusIndex = getIndexByID(user.StatusID, this.props.statuses)
                    if(statusIndex!==null){
                        const status = this.props.statuses[statusIndex]
                        user.StatusName = status.Name
                        user.StatusColor = decimalColorToHexColor(status.Color) 
                    }
                }
                return user
            })
            */
    
            return(
                <>
                    <Paper style={styles.paper}>
                        <Table size="small">
                            <TableBody>
                            {geofences.map((geofence) => 
                                <TableRow key={geofence.ID} 
                                        onClick={()=>{this.handleSelect(geofence.ID)}}
                                        onDoubleClick={()=>{this.handleMenuItemClick('properties', geofence.ID)}}
                                        style={this.getItemStyle(geofence.ID)}>
                                    <TableCell style={{width:40, position:'relative'}} >
                                        <Checkbox
                                            style={{color: decimalColorToHexColor(geofence.Color) }}
                                            checked={Boolean(geofence.ShowOnMap)} 
                                            title="ShowOnMap"
                                            name="ShowOnMap"
                                            onChange={(event)=>{this.handleInput(event, geofence.ID )}}/>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {geofence.Name}
                                    </TableCell>

                                    <TableCell style={{width:30}}>
                                        <IconButton size="small" color={this.getPaintButtonColor(geofence.ID)}  aria-label="more" 
                                            component="span"
                                            onClick={event=>this.handlePaintClick(event, geofence)}><CreateIcon />
                                        </IconButton>
                                    </TableCell>
    
                                    <TableCell style={{width:30}}>
                                        <Switch checked={Boolean(geofence.ON)} name="ON"
                                                title={t('OnOff')}
                                                onChange={(event)=>{this.handleInput(event, geofence.ID )}}
                                         />
                                    </TableCell>
                                    <TableCell style={{width:30}}>
                                        <IconButton size="small" color="inherit" aria-label="more" 
                                            component="span" title={t('DrawOnMap')}
                                            onClick={event=>this.handleMenuClick(event, geofence)}>
                                            <MoreVert />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                            <Menu anchorEl={this.state.menuAnchor} keepMounted
                                open={Boolean(this.state.menuAnchor)} 
                                onClose={this.handleMenuClose.bind(this)}>
    
                                <MenuItem onClick={()=>{this.handleMenuItemClick('PROPERTIES')}}>{t('Properties')}</MenuItem>
                                <MenuItem onClick={()=>{this.handleMenuItemClick('DELETE')}}>{t('Delete')}</MenuItem>
                            </Menu>
                        </Table>
                    </Paper>
                </>
            )
    
        }


}



export const GeofencesListEditor = withTranslation()(GeofencesListEditor_);